import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { StyledTextWrapper } from './styles'
import { BackButton } from '../backButton'
import { If } from '../if'
import { Text, Title } from '../text'
import { AuthContext } from '../../../context/authProvider'
import { navigate } from 'gatsby'
import { sendMobileAppEvent } from '../../../utils/mobileAppFunctionality'
import { getPreviousPage } from '../../../utils/historyFunctions'

const LoggedOutHeader = (props) => {
  const {
    description,
    title,
    hideBackButton,
    backButtonLink,
    hideDescription,
  } = props
  const { isLoggedIn } = useContext(AuthContext)

  if (isLoggedIn || (!title && !description)) return <></>

  const handleGoBack = () => {
    sendMobileAppEvent('goBack')
    navigate(backButtonLink || getPreviousPage())
  }

  return (
    <StyledTextWrapper>
      <If
        condition={!hideBackButton}
        render={() => (
          <BackButton onClick={handleGoBack} top="1.5em" left="0" />
        )}
      />

      <Title>{title}</Title>
      <If
        condition={!hideDescription && description}
        render={() => <Text>{description}</Text>}
      />
    </StyledTextWrapper>
  )
}

LoggedOutHeader.defaultProps = {
  description: '',
  title: '',
  backButtonLink: '',
  hideBackButton: false,
  hideDescription: false,
}

LoggedOutHeader.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  backButtonLink: PropTypes.string,
  hideBackButton: PropTypes.bool,
  hideDescription: PropTypes.bool,
}

export { LoggedOutHeader }
